import { useCallback, useEffect, useRef, useState } from "react";
import { getMemberTierList } from "../../services/membersAdminService";
import { MemberTierModel } from "./models/MemberTierModel";

export const useMemberTierList = () => {
    const isMoutedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<MemberTierModel[]>([]);

    useEffect(() => {
        isMoutedRef.current = true;
        return () => {
            isMoutedRef.current = false;
        }
    });

    const load = useCallback(async () => {
        if(loading)
        {
            setList([]);
            return;
        }
        try {
            setLoading(true);
            const _data = await getMemberTierList();
            if(!isMoutedRef.current)
                return;

            if(!!_data && !!_data.results)
                setList(_data.results);
        }
        finally {
            if(!isMoutedRef.current)
                return;
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, list };
}